import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { colors } from '../../constants/colors'
import { resolveMediaUrl } from '../../utils/mediaUrl'

const UserIcon = () => (
  <svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
    <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
  </svg>
)

export default function HeaderProfile({ onAiConfig, onEmbeddingGuide, onSignOut }) {
  const navigate = useNavigate()
  const user = useSelector((s) => s.auth.user)
  const [open, setOpen] = useState(false)

  useEffect(() => {
    if (!open) return
    const close = (e) => {
      if (!e.target.closest('.profile-dropdown-container')) setOpen(false)
    }
    document.addEventListener('mousedown', close)
    return () => document.removeEventListener('mousedown', close)
  }, [open])

  const itemStyle = {
    padding: '12px 16px',
    cursor: 'pointer',
    fontSize: '14px',
    color: colors.text.primary,
    borderBottom: `1px solid ${colors.borderVariants.light}`,
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  }

  return (
    <div className="profile-dropdown-container" style={{ position: 'relative' }}>
      <div
        style={{
          width: 44,
          height: 44,
          borderRadius: '50%',
          backgroundColor: user?.profile_picture ? 'transparent' : colors.primary,
          cursor: 'pointer',
          overflow: 'hidden',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: user?.profile_picture ? undefined : '#fff',
        }}
        onClick={() => setOpen((o) => !o)}
      >
        {user?.profile_picture ? (
          <img src={resolveMediaUrl(user.profile_picture)} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        ) : (
          <UserIcon />
        )}
      </div>
      {open && (
        <div
          style={{
            position: 'absolute',
            top: 52,
            right: 0,
            backgroundColor: colors.background.primary,
            border: `1px solid ${colors.borderVariants.light}`,
            borderRadius: 8,
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            minWidth: 200,
            zIndex: 1000,
          }}
        >
          <div style={itemStyle} onClick={() => { navigate('/profile'); setOpen(false); }}>
            <svg width="16" height="16" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
            </svg>
            Profile
          </div>
          {user?.role === 'Owner' && (
            <div style={itemStyle} onClick={() => { navigate('/settings'); setOpen(false); }}>
              <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                <circle cx="12" cy="12" r="3" />
                <path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42" strokeLinecap="round" />
              </svg>
              Settings
            </div>
          )}
          {onAiConfig && (
            <div style={itemStyle} onClick={() => { onAiConfig(); setOpen(false); }}>
              <svg width="16" height="16" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
              </svg>
              AI Configuration
            </div>
          )}
          {onEmbeddingGuide && (
            <div style={itemStyle} onClick={() => { onEmbeddingGuide(); setOpen(false); }}>
              <svg width="16" height="16" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
              </svg>
              Embedding Guide
            </div>
          )}
          <div style={{ ...itemStyle, borderBottom: 'none', color: colors.status.error }} onClick={onSignOut}>
            <svg width="16" height="16" fill="currentColor" viewBox="0 0 24 24">
              <path d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.59L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z"/>
            </svg>
            Logout
          </div>
        </div>
      )}
    </div>
  )
}
